import { createContext, useContext, useEffect, useRef, useState } from "react";
import { content } from "@/i18n/content";

const StudioContext = createContext(null);

export const useStudio = () => useContext(StudioContext);

export const StudioProvider = ({ children }) => {
    const [lang, setLang] = useState(() => localStorage.getItem("valrio_lang") || "pt");
    const [theme, setTheme] = useState(() => localStorage.getItem("valrio_theme") || "light");
    const [privacyOpen, setPrivacyOpen] = useState(false);
    const lenisRef = useRef(null);

    useEffect(() => {
        localStorage.setItem("valrio_lang", lang);
        document.documentElement.lang = lang;
    }, [lang]);

    useEffect(() => {
        localStorage.setItem("valrio_theme", theme);
        document.documentElement.classList.toggle("dark", theme === "dark");
    }, [theme]);

    const scrollTo = (target) => {
        if (lenisRef.current) {
            lenisRef.current.scrollTo(target, { offset: target === 0 ? 0 : -64, duration: 1.4 });
        } else if (target === 0) {
            window.scrollTo({ top: 0, behavior: "smooth" });
        } else {
            document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
        }
    };

    const t = content[lang];

    return (
        <StudioContext.Provider
            value={{ lang, setLang, theme, setTheme, t, scrollTo, lenisRef, privacyOpen, setPrivacyOpen }}
        >
            {children}
        </StudioContext.Provider>
    );
};
